import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ToastSuccessIcon from '../../assets/imageComponents/ToastSuccessIcon';
import CloseIcon from '../../assets/img/close-icon.svg';
import { MarginApproval } from './marginApproval.service';

function ApproveRejectModal({
  showModal,
  onClose,
  type,
  id,
  tabType,
  recordType,
  fetchMarginApprovalList,
  fetchAuditLogs,
  fromWoScreen,
  getWorkOrdersItems,
  fromPoScreen,
  fetchPoById,
  fromvendorWo,
}) {
  const [comments, setComments] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const approveRejectAction = async () => {
    setIsLoading(true);
    try {
      const payload =
        tabType === 'brand'
          ? {
              workOrderId: id,
              action: type,
              comment: comments,
            }
          : {
              id: id,
              action: type,
              type: recordType,
              comment: comments,
            };
      const response = await MarginApproval.marginApprovalAction(tabType, payload);
      if (response?.status === 200) {
        onClose();
        if (fromWoScreen) {
          getWorkOrdersItems();
        } else if (fromPoScreen) {
          fetchPoById(id);
        } else {
          fetchMarginApprovalList();
          fetchAuditLogs();
        }
        toast.success(
          <div className="d-flex justify-content-between">
            <div className="mr-3">
              <ToastSuccessIcon />
            </div>
            <span className="mt-2">
              {`The ${recordType === 'purchaseOrder' ? 'purchase' : 'work'} order ${id} has been
            successfully ${type === 'APPROVED' ? 'approved' : 'rejected'}!`}
            </span>
          </div>,

          {
            className: 'custom-background',
            position: 'top-center',
          }
        );
      }
    } catch (error) {
      toast.error('Something went wrong!');
    }
    setIsLoading(false);
  };

  return (
    <Modal show={showModal} closeButton onHide={onClose} centered size="md">
      <Modal.Header style={{ display: 'block' }}>
        <Row className="mb-4">
          <Col md={6}>
            <h5 className="pt-2">{type === 'APPROVED' ? 'Approving' : 'Rejecting'} Work Order</h5>
          </Col>
          <Col md={6} className="text-right">
            <Button variant="text" onClick={onClose}>
              <img src={CloseIcon} height={15} width={15} />
            </Button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Comments (if any)</Form.Label>
          <Form.Control onChange={(e) => setComments(e.target.value)} as="TextArea" />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Row>
          <Col md={12}>
            <Button variant="secondary" className="mr-2" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => approveRejectAction()}
              disabled={isLoading || isEmpty(comments)}>
              Yes, {type === 'APPROVED' ? 'Approve' : 'Reject'}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default ApproveRejectModal;
